import { NgStyle } from '@angular/common';
import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { TAGS_COLORS } from '@app-shared/constants/constants';

export const TAG_COLOR_SELECT_OPTIONS = Object.entries(TAGS_COLORS).map(
  ([key, value]) => ({ label: key, id: value })
);

export const DEFAULT_TAG_COLOR_ID = TAG_COLOR_SELECT_OPTIONS[0].id;

@Component({
  selector: 'app-tag-color-select',
  templateUrl: './tag-color-select.component.html',
  styleUrls: ['./tag-color-select.component.scss'],
  imports: [MatFormFieldModule, MatSelect, MatOption, TranslateModule, NgStyle],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TagColorSelectComponent),
      multi: true,
    },
  ],
})
export class TagColorSelectComponent implements ControlValueAccessor {
  @Input() formFieldClass = 'w-full';

  protected readonly colorsOptions = TAG_COLOR_SELECT_OPTIONS;
  protected value: string = DEFAULT_TAG_COLOR_ID;
  protected isDisabled = false;

  #onChange: (value: string) => void = () => {};
  #onTouched: () => void = () => {};

  writeValue(value: string | null): void {
    this.value = value ?? DEFAULT_TAG_COLOR_ID;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.#onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.#onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  protected onSelect(value: string): void {
    this.value = value;
    this.#onChange(value);
    this.#onTouched();
  }
}
